import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';

@Component({
  selector: 'tt-poh-comp-add-scan',
  templateUrl: './poh-comp-add-scan.component.html',
  styleUrls: ['./poh-comp-add-scan.component.css']
})
export class PohCompAddScanComponent implements OnInit {
    pohKeyno;

    public barcodeButtons: FormButton[] = [
        { id: 'calculator', icon: 'fa fa-calculator', type: 'primary', onClick: () => this.openCalculator('barcode') },
        { id: 'search', icon: 'fas fa-search', type: 'success', onClick: () => this.handleScan() }
    ];

    public barcode: string = '';

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.pohKeyno = this.stateService.getStateParams()['poh_keyno'];
    }

    private async handleScan() {
        if (!!this.pohKeyno && !!this.barcode) {
            const response = (await this.datatask.Post(157, {
                poh_keyno: this.pohKeyno,
                barcode: this.barcode
            }))[0];

            if (response) {
                this.stateService.go(response?.webpagename, {
                    poh_keyno: this.pohKeyno,
                    stock_keyno: response?.stock_keyno
                });
            }

            this.clear('barcode');
        }
    }

    private async openCalculator(id: string) {
        switch (id) {
            case 'barcode':
                if (id === 'barcode') {
                    const value = await this.modal.showCalculator(this.barcode);
                    this.barcode = value;

                    this.handleScan();
                }
                break;
            default:
                break;
        };
    }

    private clear(id: string) {
        switch (id) {
            case 'barcode':
                if (!!this.barcode) {
                    this.barcode = '';
                }
                break;
            default:
                break;
        }
    }

    public submitSearch() {
        this.handleScan();
    }

    private async init() {
        this.handleScan();
    }

    ngOnInit() {
        this.init();
    }
}
